import {
  AfterViewChecked,
  Component,
  ChangeDetectorRef,
  ElementRef,
  HostListener,
  ViewChild,
  computed,
} from "@angular/core";
import { DatePipe } from "@angular/common";
import { PeriodType } from "../../../../../models/types/filter.types";
import { ViewsDatepickerDirective } from "@bitwarden/web-vault/app/directives/views-datepicker.directive";
import { TIME_DIRECTION_AGO } from "@bitwarden/web-vault/app/components/date-picker/calendar/calendar.component";
import { calculatePickerTranslateValue, isMobileScreen } from "../datepicker-utils";

@Component({
  selector: "app-past-views-datepicker",
  templateUrl: "./past-views-datepicker.component.html",
})
export class PastViewsDatepickerComponent
  extends ViewsDatepickerDirective
  implements AfterViewChecked
{
  @ViewChild("startPicker", { read: ElementRef }) startPicker!: ElementRef;
  @ViewChild("endPicker", { read: ElementRef }) endPicker!: ElementRef;
  startPickerTranslateValue: string = "0";
  endPickerTranslateValue: string = "0";
  protected readonly AGO = TIME_DIRECTION_AGO;

  constructor(
    protected datePipe: DatePipe,
    protected elementRef: ElementRef,
    private cdr: ChangeDetectorRef,
  ) {
    super(datePipe, elementRef);
  }

  @HostListener("window:resize")
  onResize() {
    this.updateStartPickerTranslateValue();
    this.updateEndPickerTranslateValue();
  }

  ngAfterViewChecked() {
    this.updateStartPickerTranslateValue();
    this.updateEndPickerTranslateValue();
    this.cdr.detectChanges();
  }

  getStartDateFilter = computed(() => {
    const end = this.currentDateRange().endDate;
    return (date: Date) => {
      return date <= end && this.isBeforeToday(date);
    };
  });

  getEndDateFilter = computed(() => {
    const start = this.currentDateRange().startDate;
    return (date: Date) => {
      return date >= start && this.isBeforeToday(date);
    };
  });

  isBeforeToday(date: Date): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date <= today;
  }

  isMobileScreen = isMobileScreen;

  updateDate(dateRange: PeriodType) {
    this.calculationPastStoreService.period.updateSelection(dateRange);
  }

  updateStartPickerTranslateValue() {
    this.startPickerTranslateValue = calculatePickerTranslateValue(
      this.startPickerTrigger,
      this.startPicker,
    );
  }

  updateEndPickerTranslateValue() {
    this.endPickerTranslateValue = calculatePickerTranslateValue(
      this.endPickerTrigger,
      this.endPicker,
    );
  }
}
